


















































































































































































































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { IClientProviderData } from "@/models/providers/client";
import dateranges from "@/data/dateranges";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import { IAccount } from "@/models/accounts";
import { RegexMatch } from "@/data/enums/router";
import { QUERY_PARAMS } from "@/data/constants";

@Component({
  components: {
    "chart-provider": () =>
      import("@/components/app/global/stats/charts/chart/chartProvider.vue"),
    "client-payment-methods-provider": () =>
      import(
        "@/components/app/global/payments/clientPaymentMethodsProvider.vue"
      ),
    "client-payment-methods-listing": () =>
      import(
        "@/components/app/global/payments/clientPaymentMethodsListing.vue"
      ),
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "recent-invoices-list": () =>
      import("@/components/app/global/invoices/recentInvoicesList.vue"),
    "recent-orders-list": () =>
      import("@/components/app/global/orders/recentOrdersList.vue"),
    "orders-provider": () =>
      import("@/components/app/global/orders/ordersProvider.vue"),
    "transactions-total": () =>
      import("@/components/app/global/stats/transactionsTotal.vue"),
    "orders-total": () =>
      import("@/components/app/global/stats/ordersTotal.vue"),
    "amount-total-invoiced": () =>
      import("@/components/app/global/stats/amountTotalInvoiced.vue"),
    "invoices-total-active": () =>
      import("@/components/app/global/stats/invoicesTotal.vue"),
    "invoices-average-value": () =>
      import("@/components/app/global/stats/invoiceAverageValue.vue"),
    "invoices-total-overdue": () =>
      import("@/components/app/global/stats/invoicesTotalOverdue.vue"),
    "chart-revenue": () =>
      import("@/components/app/global/stats/charts/revenueChart.vue"),
    "orders-chart": () =>
      import("@/components/app/global/stats/charts/ordersChart.vue")
  }
})
export default class AdminClientBillingOverview extends Mixins(
  StatsStorageMixin
) {
  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  // Props
  @Prop({ required: true })
  public client!: IClient;

  // Data
  public range = this.tryGetStatDateFromStorage(dateranges.ranges.last30days);
  public currencyCode = null;
  public canAddOrder: boolean = this.$userCan(
    "staff_create_order",
    "list_clients"
  );

  // Getters
  public get isStaged() {
    return this.$clientProvider().isStaged;
  }

  public get accountId(): IAccount["id"] {
    return this.$_.get(this.client, "accounts[0].id");
  }

  public get adminOrderRoute() {
    return {
      name: "adminOrderShop",
      params: { basketId: RegexMatch.NEW },
      query: {
        [QUERY_PARAMS.CLIENT_ID]: this.$_.get(this.client, "id"),
        [QUERY_PARAMS.ACCOUNT_ID]: this.$_.get(this.client, "accounts[0].id")
      }
    };
  }
}
